import { StoryblokComponent } from "@storyblok/react"
import {applySpec, useWith, mergeRight, identity, path} from 'ramda';
///
// The hope is that we use these functions to render all the
// storyblok bloks so we can make sure we are always passing
// the same information to each blok
///

const withBannerAdditionalProps = useWith(mergeRight, [
  identity,
  applySpec({
    header_banner_panel: path(['content', 'ads', 'header_banner_panel']),
    article_banner_panel: path(['content', 'ads', 'article_banner_panel']),
    lower_banner_panel: path(['content', 'ads', 'lower_banner_panel']),
  })
])

function GetComponentsFromBloks(bloks, story, props) {
  if(!bloks) { return }

  const additionalProps = withBannerAdditionalProps(props, story)

  return bloks.map((blok, index)=>RenderStoryblokComponent(blok,story,null,additionalProps,index))
}

// Pass either the story or the language
// (if a blok is rendering another blok it only hass access to language)
function RenderStoryblokComponent(blok, story, language,additionalProps,index) {
  if(!blok) { return }
  let lang = language
  if(!lang) {
    lang = story ? story.lang : null
  }
  return <StoryblokComponent key={index} blok={blok} story_language={lang} {...additionalProps} />
}



export default GetComponentsFromBloks
export { RenderStoryblokComponent }
